module.exports = __webpack_public_path__ + "media/Video (13).04c217a8.mp4";